import {BranchControllerName} from "../utils/names/controllerNames";
import {BranchRouteController} from "./route/BranchRouteController";
import {BranchesListComponent} from "./components/branches_list/BranchesListComponent";
import {BrandBranchesComponent} from "./components/brands_branches/brand-branches.component";
import {BranchElement} from "./components/branch_element/BranchElement";
import {BranchModuleConfig} from "./BranchesModuleConfiguration";
import 'croppie';
import {BranchesPickerComponent} from "./components/branches_picker/branches-picker.component";
import {ImportLogComponent} from "modules/report_log/components/ImportLogComponent";

BranchModuleConfig
    .createNewModule()
    .controller(BranchControllerName, BranchRouteController.instance)
    .component('brandBranches', BrandBranchesComponent.instance)
    .component('branchElement', BranchElement.instance)
    .component('branchesPicker', BranchesPickerComponent.instance)
    .component('importTypePicker', ImportLogComponent.instance)
    .component('branchList', BranchesListComponent.instance);
